import {getSuite} from "@http/overview/buy";
export function getSuiteCommon() {
    return new Promise((resolve, reject) => {
        getSuite().then(res => {
            let {suiteConfigs, serverDateTime} = res;
            let packageTypeList = []
            let suites = []
            let titleText = ''
            packageTypeList = suiteConfigs;
            for (let i = 0; i < packageTypeList.length; i++) {
                let item = packageTypeList[i]
                if (item.suiteType === 3) {
                    suites = item.suites.slice(0, 2)
                    packageTypeList[i] = Object.assign(packageTypeList[i], {suites})
                    titleText = '新用户专享套餐（仅限一次）';
                    packageTypeList[i].isShow = true
                    break
                } else if (item.suiteType === 1) {
                    for (let j = 0; j < item.suites.length; j++) {
                        let itemJ = item.suites[j]
                        if (itemJ.tsCount === 20) {
                            suites.push(itemJ)
                        }
                        if (itemJ.tsCount === 50) {
                            suites.push(itemJ)
                        }
                    }
                    suites = suites.filter((obj, index) => {
                        return suites.findIndex((item) => item.tsCount === obj.tsCount) === index;
                    });
                    packageTypeList[i] = Object.assign(packageTypeList[i], {suites})
                    packageTypeList[i].isShow = true
                    titleText = '基本套餐';
                    break
                }

            }
            resolve({
                packageTypeList,
                titleText
            })
        })
    }).catch(e => {
        reject(e)
    })
}